/**
 * Hooks for reading URL parameters.
 *
 * Replaces Wized "parameters": course_id, playlist_id, shared_tutorial,
 *   shared_playlist, shared_playlist_course, video_id, library, dashboard
 */

import { useSearchParams } from "react-router-dom";

/** Read a single search param (returns null if not present). */
function useParam(key: string): string | null {
  const [params] = useSearchParams();
  return params.get(key);
}

/** Course page: `?course_id=...` */
export function useCourseIdParam(): string | null {
  return useParam("course_id");
}

/** Playlist page: `?playlist_id=...` */
export function usePlaylistIdParam(): string | null {
  return useParam("playlist_id");
}

/** Shared tutorial page: `?shared_tutorial=...` */
export function useSharedTutorialParam(): string | null {
  return useParam("shared_tutorial");
}

/** Shared playlist page: `?shared_playlist=...` */
export function useSharedPlaylistParam(): string | null {
  return useParam("shared_playlist");
}

/** Shared playlist course page: `?shared_playlist_course=...` */
export function useSharedPlaylistCourseParam(): string | null {
  return useParam("shared_playlist_course");
}

/** Video ID param: `?video_id=...` */
export function useVideoIdParam(): string | null {
  return useParam("video_id");
}

/** Library flag: `?library=true` (used after login to redirect back). */
export function useLibraryParam(): boolean {
  return useParam("library") === "true";
}
